/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// import FaviconBase from './favicon-base.png';
// import FaviconAddon from './favicon-addon.png';
import logo from './logo_kisra.jpg';

export const Favicon = ({ size = 100 }: { size?: number }) => (
  <div className="relative flex items-center">
    <img
      src={logo}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.21) }}
    />
    {/* <img
      src={FaviconAddon}
      className="absolute left-1/2 translate-x-[34px] top-[40px] w-[51px]"
    /> */}
  </div>
);
